// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* print.css */
@media print {
  body {
    width: 100%;
    margin: 0;
    padding: 0;
  }
  #Overall-Performance {
    width: 100%;
    margin: 0;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
  }
  .col-6 {
    width: 50%;
  }
  .col-lg-3 {
    width: 25%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Student/Performance/print.scss"],"names":[],"mappings":"AAAA,cAAA;AACA;EACE;IACE,WAAA;IACA,SAAA;IACA,UAAA;EACF;EACA;IACE,WAAA;IACA,SAAA;EACF;EACA;IACE,aAAA;IACA,eAAA;EACF;EACA;IACE,UAAA;EACF;EACA;IACE,UAAA;EACF;AACF","sourcesContent":["/* print.css */\n@media print {\n  body {\n    width: 100%;\n    margin: 0;\n    padding: 0;\n  }\n  #Overall-Performance {\n    width: 100%;\n    margin: 0;\n  }\n  .row {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .col-6 {\n    width: 50%;\n  }\n  .col-lg-3 {\n    width: 25%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
